var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "holiday-main-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { "left-arrow": "" },
          on: { "click-left": _vm.closeWeb, "click-right": _vm.handleToRule },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow02.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c("span", { staticClass: "tit-right" }, [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/rules02.png"),
                        alt: "",
                      },
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "holiday-con",
        style: { "margin-top": `-${_vm.barHeight + 46}px` },
      },
      [
        _c("div", { staticClass: "holiday-head" }, [
          _c("img", {
            staticClass: "head-img-back",
            attrs: { src: require("./images/main-bg.png") },
          }),
          _c("div", { staticClass: "head-con" }, [
            _c(
              "div",
              {
                staticClass: "head-img",
                style: { "margin-top": `${_vm.barHeight + 40}px` },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.getMatchTitle("tit-bg-", _vm.$i18n.locale),
                  },
                }),
              ]
            ),
            _c("div", { staticClass: "dead-line" }, [
              _c("div", { staticClass: "timer" }, [
                _c("span", { staticClass: "time-num" }, [
                  _c("span", [_vm._v(_vm._s(_vm.countdownResult.days))]),
                  _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k297")))]),
                ]),
                _c("span", { staticClass: "stp" }, [_vm._v(":")]),
                _c("span", { staticClass: "time-num" }, [
                  _c("span", [_vm._v(_vm._s(_vm.countdownResult.hours))]),
                  _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k364")))]),
                ]),
                _c("span", { staticClass: "stp" }, [_vm._v(":")]),
                _c("span", { staticClass: "time-num" }, [
                  _c("span", [_vm._v(_vm._s(_vm.countdownResult.minutes))]),
                  _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k365")))]),
                ]),
                _c("span", { staticClass: "stp" }, [_vm._v(":")]),
                _c("span", { staticClass: "time-num" }, [
                  _c("span", [_vm._v(_vm._s(_vm.countdownResult.seconds))]),
                  _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k366")))]),
                ]),
              ]),
            ]),
            _vm.actInfo
              ? _c("div", { staticClass: "points-rank" }, [
                  _c("div", { staticClass: "pr-item" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k221")))]),
                    _vm.actInfo
                      ? _c("div", [_vm._v(_vm._s(_vm.actInfo.score || 0))])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "pr-gap" }),
                  _c("div", { staticClass: "pr-item" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k222")))]),
                    _c("div", [_vm._v(_vm._s(_vm.actInfo.rank || "--"))]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "main-con" }, [
          _c(
            "div",
            { staticClass: "part-block", staticStyle: { "margin-top": "0" } },
            [
              _c("div", { staticClass: "part-head" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k218")))]),
              ]),
              _c("div", { staticClass: "part-tips" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k420"))),
              ]),
              _c("div", { staticClass: "holiday-reward" }, [
                _c("div", { staticClass: "holiday-item" }, [
                  _c("div", { staticClass: "reward-num" }, [_vm._v("No.1")]),
                  _c("div", { staticClass: "reward-coins" }, [
                    _vm._v(" " + _vm._s(_vm.boardData.num1Reward) + " "),
                    _c("img", {
                      staticClass: "coins-icon",
                      attrs: { src: _vm.getMatchImg("coin") },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "holiday-item" }, [
                  _c("div", { staticClass: "reward-num" }, [_vm._v("No.2")]),
                  _c("div", { staticClass: "reward-coins" }, [
                    _vm._v(" " + _vm._s(_vm.boardData.num2Reward) + " "),
                    _c("img", {
                      staticClass: "coins-icon",
                      attrs: { src: _vm.getMatchImg("coin") },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "holiday-item" }, [
                  _c("div", { staticClass: "reward-num" }, [_vm._v("No.3")]),
                  _c("div", { staticClass: "reward-coins" }, [
                    _vm._v(" " + _vm._s(_vm.boardData.num3Reward) + " "),
                    _c("img", {
                      staticClass: "coins-icon",
                      attrs: { src: _vm.getMatchImg("coin") },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "holiday-item" }, [
                  _c("div", { staticClass: "reward-num" }, [_vm._v("No.4-10")]),
                  _c("div", { staticClass: "reward-coins" }, [
                    _vm._v(" " + _vm._s(_vm.boardData.num4Reward) + " "),
                    _c("img", {
                      staticClass: "coins-icon",
                      attrs: { src: _vm.getMatchImg("coin") },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "btn-block" }, [
                _c(
                  "div",
                  {
                    staticClass: "holiday-btn",
                    on: { click: _vm.handleToRank },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k220")))]
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k435")))]),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k436"))),
            ]),
            _vm.actInfo && _vm.actInfo.signTask
              ? _c("div", { staticClass: "task-item" }, [
                  _c("span", { staticClass: "task-item-tit" }, [
                    _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k265")) + "  ("),
                    _c("span", [_vm._v(_vm._s(_vm.actInfo.signTask.proc))]),
                    _vm._v("/"),
                    _c("i", [_vm._v(_vm._s(_vm.actInfo.signTask.target))]),
                    _vm._v(") "),
                  ]),
                  _c("div", { staticClass: "task-item-reward" }, [
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("video-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x1"),
                      ]),
                    ]),
                  ]),
                  _vm.actInfo.signTask.state === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: { click: _vm.handleSign },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.commonM.k293")))]
                      )
                    : _vm._e(),
                  _vm.actInfo.signTask.state === 2
                    ? _c(
                        "div",
                        { staticClass: "task-item-btn disable" },
                        [
                          _vm.leftClassObj && _vm.leftClassObj.countdownResult
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.hours
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.minutes
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.seconds
                                    ) +
                                    " "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.actInfo && _vm.actInfo.send1Task
              ? _c("div", { staticClass: "task-item" }, [
                  _c("span", { staticClass: "task-item-tit" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k450")))]),
                    _vm._v(" ×1  ("),
                    _c("span", [_vm._v(_vm._s(_vm.actInfo.send1Task.proc))]),
                    _vm._v("/"),
                    _c("i", [_vm._v(_vm._s(_vm.actInfo.send1Task.target))]),
                    _vm._v(") "),
                  ]),
                  _c("div", { staticClass: "task-item-reward" }, [
                    _vm.packageName !== "echo"
                      ? _c("div", { staticClass: "task-item-gift" }, [
                          _vm._m(0),
                          _c("div", { staticClass: "item-gift-num" }, [
                            _vm._v("x1"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.packageName !== "echo"
                      ? _c("div", { staticClass: "task-item-gap" })
                      : _vm._e(),
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("video-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x1"),
                      ]),
                    ]),
                    _c("div", { staticClass: "task-item-gap" }),
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("super-chat-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x1"),
                      ]),
                    ]),
                  ]),
                  _vm.actInfo.send1Task.state === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: { click: _vm.handleToChatList },
                        },
                        [
                          _c("img", {
                            attrs: { src: require("./images/btn-arrow.png") },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm.actInfo.send1Task.state === 1
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: {
                            click: function ($event) {
                              return _vm.handleClaim(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                      )
                    : _vm._e(),
                  _vm.actInfo.send1Task.state === 2
                    ? _c(
                        "div",
                        { staticClass: "task-item-btn disable" },
                        [
                          _vm.leftClassObj && _vm.leftClassObj.countdownResult
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.hours
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.minutes
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.seconds
                                    ) +
                                    " "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.actInfo && _vm.actInfo.send5Task
              ? _c("div", { staticClass: "task-item" }, [
                  _c("span", { staticClass: "task-item-tit" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k450")))]),
                    _vm._v(" ×5  ("),
                    _c("span", [_vm._v(_vm._s(_vm.actInfo.send5Task.proc))]),
                    _vm._v("/"),
                    _c("i", [_vm._v(_vm._s(_vm.actInfo.send5Task.target))]),
                    _vm._v(") "),
                  ]),
                  _c("div", { staticClass: "task-item-reward" }, [
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("coupon") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x1"),
                      ]),
                    ]),
                    _c("div", { staticClass: "task-item-gap" }),
                    _vm.packageName !== "echo"
                      ? _c("div", { staticClass: "task-item-gift" }, [
                          _vm._m(1),
                          _c("div", { staticClass: "item-gift-num" }, [
                            _vm._v("x3"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.packageName !== "echo"
                      ? _c("div", { staticClass: "task-item-gap" })
                      : _vm._e(),
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("video-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x3"),
                      ]),
                    ]),
                    _c("div", { staticClass: "task-item-gap" }),
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("super-chat-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x3"),
                      ]),
                    ]),
                  ]),
                  _vm.actInfo.send5Task.state === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: { click: _vm.handleToChatList },
                        },
                        [
                          _c("img", {
                            attrs: { src: require("./images/btn-arrow.png") },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm.actInfo.send5Task.state === 1
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: {
                            click: function ($event) {
                              return _vm.handleClaim(5)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                      )
                    : _vm._e(),
                  _vm.actInfo.send5Task.state === 2
                    ? _c(
                        "div",
                        { staticClass: "task-item-btn disable" },
                        [
                          _vm.leftClassObj && _vm.leftClassObj.countdownResult
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.hours
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.minutes
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.seconds
                                    ) +
                                    " "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.actInfo && _vm.actInfo.send10Task
              ? _c("div", { staticClass: "task-item" }, [
                  _c("span", { staticClass: "task-item-tit" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k450")))]),
                    _vm._v(" ×10  ("),
                    _c("span", [_vm._v(_vm._s(_vm.actInfo.send10Task.proc))]),
                    _vm._v("/"),
                    _c("i", [_vm._v(_vm._s(_vm.actInfo.send10Task.target))]),
                    _vm._v(") "),
                  ]),
                  _c("div", { staticClass: "task-item-reward" }, [
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("coupon") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x2"),
                      ]),
                    ]),
                    _c("div", { staticClass: "task-item-gap" }),
                    _vm.packageName !== "echo"
                      ? _c("div", { staticClass: "task-item-gift" }, [
                          _vm._m(2),
                          _c("div", { staticClass: "item-gift-num" }, [
                            _vm._v("x5"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.packageName !== "echo"
                      ? _c("div", { staticClass: "task-item-gap" })
                      : _vm._e(),
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("video-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x5"),
                      ]),
                    ]),
                    _c("div", { staticClass: "task-item-gap" }),
                    _c("div", { staticClass: "task-item-gift" }, [
                      _c("div", { staticClass: "item-gift-img" }, [
                        _c("img", {
                          attrs: { src: _vm.getMatchImg("super-chat-pass") },
                        }),
                      ]),
                      _c("div", { staticClass: "item-gift-num" }, [
                        _vm._v("x5"),
                      ]),
                    ]),
                  ]),
                  _vm.actInfo.send10Task.state === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: { click: _vm.handleToChatList },
                        },
                        [
                          _c("img", {
                            attrs: { src: require("./images/btn-arrow.png") },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm.actInfo.send10Task.state === 1
                    ? _c(
                        "div",
                        {
                          staticClass: "task-item-btn blue",
                          on: {
                            click: function ($event) {
                              return _vm.handleClaim(10)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                      )
                    : _vm._e(),
                  _vm.actInfo.send10Task.state === 2
                    ? _c(
                        "div",
                        { staticClass: "task-item-btn disable" },
                        [
                          _vm.leftClassObj && _vm.leftClassObj.countdownResult
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.hours
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.minutes
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.seconds
                                    ) +
                                    " "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "part-block",
              staticStyle: { background: "#f4faf2" },
            },
            [
              _c("div", { staticClass: "part-head" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k448")))]),
              ]),
              _c("div", { staticClass: "part-tips" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k449"))),
              ]),
              _c("div", { staticClass: "holiday-gift" }, [
                _c("div", { staticClass: "gift-round" }, [
                  _c("div", { staticClass: "gift-cost" }, [
                    _vm._v("+1 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                  ]),
                  _vm._m(3),
                  _c("div", { staticClass: "gift-name" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k454"))),
                  ]),
                ]),
                _c("div", { staticClass: "gift-round" }, [
                  _c("div", { staticClass: "gift-cost" }, [
                    _vm._v("+3 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                  ]),
                  _vm._m(4),
                  _c("div", { staticClass: "gift-name" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k211"))),
                  ]),
                ]),
                _c("div", { staticClass: "gift-round" }, [
                  _c("div", { staticClass: "gift-cost" }, [
                    _vm._v("+7 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                  ]),
                  _vm._m(5),
                  _c("div", { staticClass: "gift-name" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k451"))),
                  ]),
                ]),
                _c("div", { staticClass: "gift-round" }, [
                  _c("div", { staticClass: "gift-cost" }, [
                    _vm._v("+15 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                  ]),
                  _vm._m(6),
                  _c("div", { staticClass: "gift-name" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k305"))),
                  ]),
                ]),
                _c("div", { staticClass: "gift-round" }, [
                  _c("div", { staticClass: "gift-cost" }, [
                    _vm._v("+80 " + _vm._s(_vm.$t("lang.commonM.k260"))),
                  ]),
                  _vm._m(7),
                  _c("div", { staticClass: "gift-name" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k214"))),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]
    ),
    _vm.showSuccess
      ? _c("div", { staticClass: "act-mask" }, [
          _c(
            "div",
            {
              staticClass: "dia-bg",
              class: [
                _vm.showSuccess === 3 || _vm.showSuccess === 4
                  ? "dia-bg2"
                  : "dia-bg1",
              ],
            },
            [
              _c(
                "div",
                { staticClass: "con-block" },
                [
                  _c("div", { staticClass: "gifts-tit" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k147")) + "!"),
                    ]),
                  ]),
                  _vm.showSuccess === 1
                    ? _c("div", { staticClass: "gifts" }, [
                        _c("div", [
                          _c("div", { staticClass: "img-wrap img-big" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("video-pass"),
                                alt: "",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "rewards-name" }, [
                            _vm._v(_vm._s(_vm.$t("lang.commonM.k087"))),
                          ]),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v("x1"),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.showSuccess === 2
                    ? _c("div", { staticClass: "gifts" }, [
                        _vm.packageName !== "echo"
                          ? _c("div", [
                              _vm._m(8),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.commonM.k451"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x1"),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", [
                          _c("div", { staticClass: "img-wrap" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("video-pass"),
                                alt: "",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "rewards-name" }, [
                            _vm._v(_vm._s(_vm.$t("lang.commonM.k087"))),
                          ]),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v("x1"),
                          ]),
                        ]),
                        _c("div", [
                          _c("div", { staticClass: "img-wrap" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.getMatchImg("super-chat-pass"),
                                alt: "",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "rewards-name" }, [
                            _vm._v(_vm._s(_vm.$t("lang.commonM.k088"))),
                          ]),
                          _c("div", { staticClass: "rewards-count" }, [
                            _vm._v("x1"),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.showSuccess === 3
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "gifts tworow",
                            staticStyle: {
                              "justify-content": "space-around",
                              "margin-bottom": "0",
                            },
                          },
                          [
                            _vm.packageName !== "echo"
                              ? _c("div", [
                                  _vm._m(9),
                                  _c("div", { staticClass: "rewards-name" }, [
                                    _vm._v(_vm._s(_vm.$t("lang.commonM.k451"))),
                                  ]),
                                  _c("div", { staticClass: "rewards-count" }, [
                                    _vm._v("x3"),
                                  ]),
                                ])
                              : _vm._e(),
                            _c("div", [
                              _c("div", { staticClass: "img-wrap" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("super-chat-pass"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.commonM.k088"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x3"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "gifts tworow",
                            staticStyle: { "justify-content": "space-around" },
                          },
                          [
                            _c("div", [
                              _c("div", { staticClass: "img-wrap" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("video-pass"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.commonM.k087"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x3"),
                              ]),
                            ]),
                            _c("div", [
                              _c("div", { staticClass: "img-wrap" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("coupon"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.giftSign.coupon"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x1"),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm.showSuccess === 4
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "gifts tworow",
                            staticStyle: {
                              "justify-content": "space-around",
                              "margin-bottom": "0",
                            },
                          },
                          [
                            _vm.packageName !== "echo"
                              ? _c("div", [
                                  _vm._m(10),
                                  _c("div", { staticClass: "rewards-name" }, [
                                    _vm._v(_vm._s(_vm.$t("lang.commonM.k451"))),
                                  ]),
                                  _c("div", { staticClass: "rewards-count" }, [
                                    _vm._v("x5"),
                                  ]),
                                ])
                              : _vm._e(),
                            _c("div", [
                              _c("div", { staticClass: "img-wrap" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("super-chat-pass"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.commonM.k088"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x5"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "gifts tworow",
                            staticStyle: { "justify-content": "space-around" },
                          },
                          [
                            _c("div", [
                              _c("div", { staticClass: "img-wrap" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("video-pass"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.commonM.k087"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x5"),
                              ]),
                            ]),
                            _c("div", [
                              _c("div", { staticClass: "img-wrap" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("coupon"),
                                    alt: "",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "rewards-name" }, [
                                _vm._v(_vm._s(_vm.$t("lang.giftSign.coupon"))),
                              ]),
                              _c("div", { staticClass: "rewards-count" }, [
                                _vm._v("x2"),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "gifts-confirm",
                      on: {
                        click: function ($event) {
                          _vm.showSuccess = 0
                        },
                      },
                    },
                    [_c("div", [_vm._v(_vm._s(_vm.$t("lang.ok")))])]
                  ),
                ],
                2
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-gift-img" }, [
      _c("img", { attrs: { src: require("./images/avatar-bar.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-gift-img" }, [
      _c("img", { attrs: { src: require("./images/avatar-bar.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-gift-img" }, [
      _c("img", { attrs: { src: require("./images/avatar-bar.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gift-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/common/Gem.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gift-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/common/Ring.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gift-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/common/Fireworks.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gift-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/common/Kiss.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gift-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/common/Candy.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: { src: require("./images/avatar-bar.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: { src: require("./images/avatar-bar.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: { src: require("./images/avatar-bar.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }